import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useEffect, useState } from 'react'
import '../dashboard.css'
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
} from '@mui/material'
import { Box } from '@mui/system'
import DeleteIcon from '@mui/icons-material/Delete'
import ModeIcon from '@mui/icons-material/Mode'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { SimpleCard } from 'app/components'
import axios from 'axios'
import { Apis } from 'app/Apis/Apis'
import Switch from '@mui/material/Switch'
import AlertDialog from './PromptBox'
import { Container, StyledTable } from '../utils/Utils'
import { Link as Weblink } from '@mui/material'

function LocationList() {
    const [location, setLocation] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const [page, setPage] = React.useState(0)
    const [openDeleteBox, setOpenDeleteBox] = React.useState(false)
    const [select, setSelect] = useState(0)
    const [deleteId, setDeleteId] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [locationOnSelectAll, setLocationOnSelectAll] = useState(0)
    const [filter, setFilter] = useState('')

    const deleteIdsAll = []
    let config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    const EmptySelectProperty = () => {
        setLocationOnSelectAll(0)
        setSelect(0)
        setSelectAll(false)
    }

    const setLocationData = async () => {
        await axios
            .get(`${Apis?.getLocations}`, config)
            .then((res) => {
                setLocation(res?.data?.data)
            })
            .catch((err) => {
                console.log('Error in SetLocationData', err)
            })
    }

    const changeStatus = async (data) => {
        const StatusData = {
            status: data.status,
            _id: data.id,
        }

        axios
            .put(`${Apis?.editStatus}`, StatusData, config)
            .then((res) => {
                console.log(res?.data?.message)
                setLocationData()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        setLocationData()
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    useEffect(() => {}, [select])

    const handleChange = (e) => {
        const { name, checked } = e.target
        if (checked === true) {
            setSelect(select + 1)
            setLocationOnSelectAll(locationOnSelectAll + 1)
            locationOnSelectAll >= 1 ? setSelectAll(true) : console.log('')
        }

        if (checked === false) {
            setSelect(select - 1)
            locationOnSelectAll <= 1 ? setSelectAll(false) : console.log('')
            setLocationOnSelectAll(locationOnSelectAll - 1)
        }

        if (name === 'allSelect') {
            locationOnSelectAll >= 1
                ? setSelectAll(true)
                : setSelectAll(!selectAll)
            setLocationOnSelectAll(
                locationOnSelectAll === 0 && select === 0 ? location.length : 0
            )
            locationOnSelectAll === location.length
                ? setSelectAll(false)
                : console.log()
            if (locationOnSelectAll === location.length) {
                setSelect(0)
            }
            if (locationOnSelectAll < location.length) {
                setSelect(location.length)
            }

            if (
                select === location.length &&
                selectAll === true &&
                locationOnSelectAll === 0
            ) {
                setSelect(0)
            }

            let tempLocation = location.map((loc) => {
                return { ...loc, isChecked: checked }
            })
            setLocation(tempLocation)
        } else {
            let tempLocation = location.map((loc) =>
                loc._id === name ? { ...loc, isChecked: checked } : loc
            )
            setLocation(tempLocation)
        }
    }

    const deleteLocation = async () => {
        setTimeout(() => {
            setLocationData()
            EmptySelectProperty()
            location.length <= 1 ? setLocation([]) : console.log('')
        }, 1000)

        console.log(deleteId?._id, localStorage.getItem('accessToken'))
        await axios
            .delete(`${Apis.deleteLocation}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'accessToken'
                    )}`,
                },
                data: {
                    _id: [deleteId?._id],
                },
            })
            .then((res) => {
                console.log(res)
            })
            .catch((err) => {
                console.log('Error in deleteLocation' + err)
            })
    }

    const deleteAllLocation = async (e) => {
        try {
            location
                ?.map((i) => {
                    i?.isChecked ? deleteIdsAll.push(i._id) : console.log('')
                })
                .then(async (res) => {
                    console.log(res)
                })
        } catch {
        } finally {
            setTimeout(async () => {
                await axios.delete(`${Apis.deleteLocation}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'accessToken'
                        )}`,
                    },
                    data: {
                        _id: deleteIdsAll,
                    },
                })

                setLocationData()
                EmptySelectProperty()
            }, 200)
            setTimeout(() => {
                setLocation([])
                setLocationData()
            }, 1000)
        }
    }

    const removeData = (data) => {
        setOpenDeleteBox(true)
        setDeleteId(data)
    }

    const promptBoxData = {
        openDeleteBox: openDeleteBox,
        setOpenDeleteBox: setOpenDeleteBox,
        deleteLocation: deleteLocation,
        deleteAllLocation: deleteAllLocation,
        selectAll: selectAll,
        select: select,
        locationData: deleteId,
    }

    return (
        <Container>
            <AlertDialog data={promptBoxData} />
            <Box
                sx={{
                    fontWeight: 600,
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                Location list
            </Box>
            <Box py="12px" />

            <div className="container my-4" style={{ width: '100%' }}>
                <div
                    className="breadcrumb"
                    style={{ width: '100%', justifyContent: 'end' }}
                >
                    <div>
                        {select >= 2 || selectAll ? (
                            <Button
                                variant="contained"
                                sx={{ marginRight: 2 }}
                                onClick={removeData}
                            >
                                Delete all
                            </Button>
                        ) : (
                            ''
                        )}

                        <Link
                            variant="contained"
                            to={'/dashboard/location/addLocation'}
                        >
                            <Button variant="contained">Add location</Button>
                        </Link>
                    </div>
                </div>

                <div className="form w-100"></div>

                <SimpleCard title="">
                    <Box>
                        <input
                            type="text"
                            style={{ float: 'right' }}
                            placeholder="Search by area"
                            onChange={(e) => {
                                setFilter(e.target.value)
                            }}
                        />
                    </Box>

                    <Box width="100%" overflow="auto">
                        <StyledTable id="StyledTable">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            paddingLeft: 20,
                                            width: '20%',
                                        }}
                                    >
                                        {location[0] ? (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="allSelect"
                                                        checked={
                                                            !location.some(
                                                                (locCheck) =>
                                                                    locCheck?.isChecked !==
                                                                    true
                                                            )
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                }
                                            />
                                        ) : (
                                            ''
                                        )}{' '}
                                        Area / Zone
                                    </TableCell>
                                    <TableCell>GPS coordinates</TableCell>
                                    <TableCell>Google maps link</TableCell>
                                    <TableCell>Radius served (KM)</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell> </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {location

                                    ?.filter((name) =>
                                        name.area?.includes(filter)
                                    )
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    ?.map((loc, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align="left"
                                                style={{
                                                    paddingLeft: 20,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'start',
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        className="sadsadsadsadsad"
                                                        control={
                                                            <Checkbox
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name={loc._id}
                                                                checked={
                                                                    loc?.isChecked ||
                                                                    false
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />
                                                        }
                                                        label=""
                                                    />

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        <Link
                                                            style={{
                                                                textDecoration:
                                                                    'none',
                                                                color: 'black',
                                                                paddingTop:
                                                                    '10px',
                                                                position:
                                                                    'relative',
                                                            }}
                                                            to={`/dashboard/profile?_id=${loc._id}`}
                                                        >
                                                            {loc?.area}
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Box>
                                                    {
                                                        loc?.gpsCoordinates
                                                            ?.latitude
                                                    }
                                                </Box>
                                                <Box>
                                                    {
                                                        loc?.gpsCoordinates
                                                            ?.longitude
                                                    }
                                                </Box>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Weblink>
                                                    {loc?.gMapsLink}
                                                </Weblink>
                                            </TableCell>
                                            <TableCell>{loc?.radius}</TableCell>
                                            <TableCell>
                                                {loc?.status
                                                    ? 'Active'
                                                    : 'Inactive'}
                                            </TableCell>

                                            <TableCell>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <IconButton>
                                                        <Switch
                                                            checked={
                                                                loc?.status
                                                            }
                                                            value=""
                                                            onClick={(e) => {
                                                                changeStatus({
                                                                    id: loc?._id,
                                                                    status: loc?.status
                                                                        ? false
                                                                        : true,
                                                                })
                                                            }}
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => {
                                                            removeData(loc)
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                    <Link
                                                        variant="contained"
                                                        to={`/dashboard/location/editLocation?_id=${loc._id}`}
                                                    >
                                                        <IconButton>
                                                            <ModeIcon />
                                                        </IconButton>
                                                    </Link>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </StyledTable>

                        <TablePagination
                            id="TablePagination"
                            style={{
                                display: 'flex !important',
                                alignItems: 'center !important',
                                justifyContent: 'center !important',
                            }}
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={location.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Box>
                </SimpleCard>
            </div>
        </Container>
    )
}

export default LocationList
